import { FC } from 'react';
import { DetailsBooking } from 'types';
import FinalisingBookingStateMessage from './FinalisingBookingStateMessage';
import BlockedStateMessage from './BlockedStateMessage';

interface ChangeStateMessageProps {
  booking: DetailsBooking;
}

const ChangeStateMessage: FC<ChangeStateMessageProps> = ({ booking }) => {
  const { isBlocked, isChangeInProgress, isFinalising } = booking.flags;

  if (isFinalising) {
    return <FinalisingBookingStateMessage booking={booking} />;
  }

  if (isBlocked || isChangeInProgress) {
    return <BlockedStateMessage booking={booking} />;
  }

  return null;
};

export default ChangeStateMessage;
